import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from "../utils";
import DetailsHandlerDef from "./DetailsHandlerDef";
export default Class(DetailsHandlerDef, {
  initialize: function initialize(options) {
    DetailsHandlerDef.prototype.initialize.apply(this, [options]);
    if (options.detailhandlers) this._detailHandlers = options.detailhandlers;else this._detailHandlers = [];
  },

  set detailhandlers(dhCollection) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = dhCollection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var detailhandler = _step.value;
        this.addDetailHandler(detailhandler);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },

  addDetailHandler: function addDetailHandler(detailHandler) {
    this._detailHandlers.push(detailHandler);
  },
  handler: function () {
    var _handler = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(result) {
      var detailItems, promises, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, detailHandler, detailHandlerResults, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, detailHandlerResult;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              detailItems = [];
              promises = [];
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 5;

              for (_iterator2 = this._detailHandlers[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                detailHandler = _step2.value;
                if (detailHandler.isApplicable(result)) promises.push(detailHandler.handler(result, this.more));
              }

              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](5);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 13:
              _context.prev = 13;
              _context.prev = 14;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 16:
              _context.prev = 16;

              if (!_didIteratorError2) {
                _context.next = 19;
                break;
              }

              throw _iteratorError2;

            case 19:
              return _context.finish(16);

            case 20:
              return _context.finish(13);

            case 21:
              _context.next = 23;
              return Promise.all(promises);

            case 23:
              detailHandlerResults = _context.sent;
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context.prev = 27;

              for (_iterator3 = detailHandlerResults[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                detailHandlerResult = _step3.value;
                detailItems = [].concat(_toConsumableArray(detailItems), _toConsumableArray(detailHandlerResult));
              }

              _context.next = 35;
              break;

            case 31:
              _context.prev = 31;
              _context.t1 = _context["catch"](27);
              _didIteratorError3 = true;
              _iteratorError3 = _context.t1;

            case 35:
              _context.prev = 35;
              _context.prev = 36;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 38:
              _context.prev = 38;

              if (!_didIteratorError3) {
                _context.next = 41;
                break;
              }

              throw _iteratorError3;

            case 41:
              return _context.finish(38);

            case 42:
              return _context.finish(35);

            case 43:
              return _context.abrupt("return", detailItems);

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[5, 9, 13, 21], [14,, 16, 20], [27, 31, 35, 43], [36,, 38, 42]]);
    }));

    function handler(_x) {
      return _handler.apply(this, arguments);
    }

    return handler;
  }(),
  isApplicable: function isApplicable(result) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = this._detailHandlers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var detailHandler = _step4.value;
        if (detailHandler.isApplicable(result)) return true;
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return false;
  },
  CLASS_NAME: 'Septima.Search.ComposedDetailsHandler'
});